<template lang="html">
  <div>
    <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
      <div class="flex flex-wrap-reverse items-center data-list-btn-container">
        <!-- ADD NEW -->
        <div class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary" >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />

          <span class="ml-2 text-base text-primary">Add New</span>
        </div>
      </div>
    </div>
    <vs-table
      multiple
      v-model="selected"
      pagination
      max-items="7"
      search
      :data="users">
      <template slot="header">
        <h3>
          Students
        </h3>
      </template>
      <template slot="thead">
        <vs-th sort-key="name">
          Name
        </vs-th>
        <vs-th sort-key="parent">
          Parent
        </vs-th>
        <vs-th sort-key="rooms">
          Rooms
        </vs-th>
        <vs-th sort-key="tags">
          Tags
        </vs-th>
        <vs-th sort-key="tags">
          Actions
        </vs-th>
      </template>
      <template slot-scope="{data}">
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" >
          <vs-td :data="data[indextr].name">
            {{data[indextr].name}}
          </vs-td>
          <vs-td :data="data[indextr].parent">
            {{data[indextr].parent}}
            
            <br v-if="data[indextr].parent != ''" />
            <vs-button v-if="data[indextr].parent != ''" color="warning" type="line">Add Cam User</vs-button>

            <vs-button v-if="data[indextr].parent == ''" color="primary" type="border">Add Cam User</vs-button>
          </vs-td>
          <vs-td :data="data[indextr].id">
            {{data[indextr].website}}
          </vs-td>
          <vs-td :data="data[indextr].id">
            {{data[indextr].id}}
          </vs-td>
          <vs-td class="whitespace-no-wrap">
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />
            <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <pre>{{ selected }}</pre>
  </div>
</template>
<script>
export default {
  name: 'Student.vue',
  data: () => ({
    selected: [],
    users: [
      {
        'id': 1,
        'name': 'Leanne Graham',
        'parent': 'Sincere',
        'website': 'hildegard'
      },
      {
        'id': 2,
        'name': 'Ervin Howell',
        'parent': 'Shanna',
        'website': 'anastasia'
      },
      {
        'id': 3,
        'name': 'Clementine Bauch',
        'parent': '',
        'website': 'ramiro'
      },
      {
        'id': 4,
        'name': 'Patricia Lebsack',
        'parent': 'Julianne.OConner',
        'website': 'kale'
      },
      {
        'id': 5,
        'name': 'Chelsey Dietrich',
        'parent': 'Lucio_Hettinger',
        'website': 'demarco'
      },
      {
        'id': 6,
        'name': 'Mrs. Dennis Schulist',
        'parent': '',
        'website': 'ola'
      },
      {
        'id': 7,
        'name': 'Kurtis Weissnat',
        'parent': 'Telly.Hoeger',
        'website': 'elvis'
      },
      {
        'id': 8,
        'name': 'Nicholas Runolfsdottir V',
        'parent': 'Sherwood',
        'website': 'jacynthe'
      },
      {
        'id': 9,
        'name': 'Glenna Reichert',
        'parent': 'Chaim_McDermott',
        'website': 'conrad'
      },
      {
        'id': 10,
        'name': 'Clementina DuBuque',
        'parent': 'Rey.Padberg',
        'website': 'ambrose'
      }
    ]
  })
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
        box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
        td{
          padding: 20px;
          &:first-child{
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }
          &:last-child{
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }
        td.td-check{
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
